export const SIGNATURE_INTEGRATION_TYPES = {
  EMBEDDED: "embedded",
  EMBEDDED_SAML: "embedded_saml",
  REDIRECT: "redirect",
  NO_SIGNATURE: "no_signature",
  ASYNC: "async",
};
